
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.8 2.4c.442 0 .8.357.8.8v3.387l2.786-1.672a.799.799 0 11.822 1.372L10.354 8l2.857 1.715a.799.799 0 11-.822 1.372l-2.79-1.675V12.8A.799.799 0 118 12.8V9.412l-2.786 1.673a.799.799 0 11-.822-1.372L7.246 8 4.389 6.285a.799.799 0 11.822-1.373l2.79 1.675V3.2c0-.443.357-.8.799-.8z","fill":"#313131"}})])
          )
        }
      }
    